import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Credentials|Status`;

const sharedLocProps: { htmlAllowed: boolean; feature: HubFeature; portal: LocPortal } = {
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'CP',
};
export type CPCertStatusPage =
	| 'CPCertStatusName'
	| 'CPCertStatusNameAbbreviation'
	| 'CPCertStatusGroupName'
	| 'CPCertStatusStatus'
	| 'CPCertStatusActiveDate'
	| 'CPCertStatusInactiveDate'
	| 'CPCertStatusExpireDate'
	| 'CPCertStatusProgramNumber'
	| 'CPCertStatusAction'
	| 'CPCertStatusEmpty'
	| 'CPCertStatusViewMore'
	| 'CPCertStatusSnowflakeBadgeId'
	| 'CPCertStatusFilterByGroupLabel';

export const cpCertStatusLocs: LocDefs<CPCertStatusPage> = {
	CPCertStatusName: {
		...sharedLocProps,
		defaultValue: 'Name',
		description: 'Column heading for the name column.',
		displayPath: `${dpRoot}|Column Heading|Name`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.Name',
	},
	CPCertStatusNameAbbreviation: {
		...sharedLocProps,
		defaultValue: 'Name Abbreviation',
		description: 'Column heading for the name abbreviation column.',
		displayPath: `${dpRoot}|Column Heading|Name Abbreviation`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.NameAbbreviation',
	},
	CPCertStatusGroupName: {
		...sharedLocProps,
		defaultValue: 'Group Name',
		description: 'Column heading for the name abbreviation column.',
		displayPath: `${dpRoot}|Column Heading|Group Name`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.GroupName',
	},
	CPCertStatusStatus: {
		...sharedLocProps,
		defaultValue: 'Status',
		description: 'Column heading for the status column.',
		displayPath: `${dpRoot}|Column Heading|Status`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.Status',
	},
	CPCertStatusActiveDate: {
		...sharedLocProps,
		defaultValue: 'Active date',
		description: 'Column heading for the active date column.',
		displayPath: `${dpRoot}|Column Heading|Active Date`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.ActiveDate',
	},
	CPCertStatusInactiveDate: {
		...sharedLocProps,
		defaultValue: 'Inactive date',
		description: 'Column heading for the inactive date column.',
		displayPath: `${dpRoot}|Column Heading|Inactive Date`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.InactiveDate',
	},
	CPCertStatusExpireDate: {
		...sharedLocProps,
		defaultValue: 'Expire date',
		description: 'Column heading for the expire date column.',
		displayPath: `${dpRoot}|Column Heading|Expire Date`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.ExpireDate',
	},
	CPCertStatusProgramNumber: {
		...sharedLocProps,
		defaultValue: 'Program number',
		description: 'Column heading for the program number column.',
		displayPath: `${dpRoot}|Column Heading|Program number`,
		displayType: 'Label',
		legacyName: 'Credential/Credentials.Status.FieldLabel.ProgramNumber',
	},
	CPCertStatusAction: {
		...sharedLocProps,
		defaultValue: '',
		description: 'Column heading for the action column.',
		displayPath: `${dpRoot}|Column Heading|Action`,
		displayType: 'Label',
	},
	CPCertStatusEmpty: {
		...sharedLocProps,
		defaultValue: 'Never',
		description: 'Content shown when expire date never happens',
		displayPath: `${dpRoot}|Content|Never`,
		displayType: 'Content',
	},
	CPCertStatusViewMore: {
		...sharedLocProps,
		defaultValue: 'View More',
		description: 'Button to View More Information',
		displayPath: `${dpRoot}|Button|View More`,
		displayType: 'Button',
		legacyName: 'Credential/Credentials.Status.Button.ViewMore',
	},
	CPCertStatusSnowflakeBadgeId: {
		...sharedLocProps,
		feature: HubFeature.SnowflakeDisplayBadgeId,
		defaultValue: 'Credential ID',
		description: 'Column heading for: Credential ID.',
		displayPath: `${dpRoot}|Column Heading|Credential ID`,
		displayType: 'Label',
	},
	CPCertStatusFilterByGroupLabel: {
		...sharedLocProps,
		defaultValue: 'Filter by Group',
		displayPath: `${dpRoot}|Filter by Group Label`,
		description: 'Label for filter by group.',
		displayType: 'Label',
	},
};

export const LOC_KEYS = MapLocKeys<CPCertStatusPage>({ ...cpCertStatusLocs });
